import { connect } from 'react-redux';
import { get } from 'lodash';
import Tag from './LoadableTagLabel';

const enhance = connect(({ tags }, { id, provider }) => ({
    item: get(tags, [provider, id]),
}));

export default enhance(Tag);
